export default __webpack_public_path__ + "static/media/logoNoShadow.cb542ec8.svg";